export const SET_MONITOR_LAYOUT = 'SET_MONITOR_LAYOUT';
export const TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR';
export const SET_SELECTED_CAMERA = 'SET_SELECTED_CAMERA';
